import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import Button from '../controls/forms/redesign/FormButton';
import selectors from 'src/selectors';
import { IRootState } from 'src/reducers';
import { connect } from 'react-redux';
import actions from 'src/actions';

interface IDialogStateProps {
    isOpen: boolean;
}
interface IDialogOwnProps {
    title: string;
    dialogName: string;
    children: Array<JSX.Element> | JSX.Element;
    subDialogHeader?: string;
    subDialog?: () => JSX.Element;
    subDialogShowing?: boolean;
    onCloseDialog?: () => void;
    bodyStyle?: React.CSSProperties;
    isExitButtonInvisible?: boolean;
    // Overrides the close button's icon (default: the Font Awesome kit's "fas fa-times", which
    // renders via an external script mutating the DOM outside React - callers whose dialog
    // re-renders frequently right after opening can lose a race against that script and end up
    // with an empty, collapsed-looking icon). Pass a react-icons element (already a dependency)
    // instead to render a real React SVG with no such race.
    exitIcon?: React.ReactNode;
}

interface IDialogDispatchProps {
    hideDialog: () => void;
}

type IDialogProps = IDialogStateProps & IDialogOwnProps & IDialogDispatchProps;

class Dialog extends React.Component<IDialogProps> {
    hideDialog = () => {
        if (this.props.onCloseDialog) {
            this.props.onCloseDialog();
        }
        this.props.hideDialog();
    };

    disableWheel = (e: Event) => {
        e.preventDefault();
    };

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('no-scroll');
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IDialogStateProps) {
        if (this.props.isOpen !== nextProps.isOpen) {
            if (nextProps.isOpen) {
                document.getElementsByTagName('html')[0].classList.add('no-scroll');
            } else {
                document.getElementsByTagName('html')[0].classList.remove('no-scroll');
            }
        }
    }

    showSubDialog = () => {
        if (this.props.subDialogShowing && this.props.subDialog) {
            return (
                <>
                    <div className="dlc-dialog-subdialog">
                        {this.props.subDialogHeader && <div className="dlc-dialog-subdialog-header">{this.props.subDialogHeader}</div>}
                        <div className="dlc-dialog-subdialog-content">{this.props.subDialog()}</div>
                    </div>
                    <div className="dlc-dialog-subdialog-background" />
                </>
            );
        }

        return undefined;
    };

    render() {
        return (
            <CSSTransition in={this.props.isOpen} timeout={300} classNames="dlc-dialog-background" unmountOnExit={true}>
                <div className="dlc-dialog-background">
                    <div className="dlc-dialog" style={this.props.bodyStyle ? this.props.bodyStyle : { maxWidth: 'calc(100% - 4rem)' }}>
                        { !this.props.isExitButtonInvisible && <div className="dlc-dialog-close" onClick={this.hideDialog}>
                            <span className="dlc-dialog-close-icon">
                                {this.props.exitIcon ?? <i className="fas fa-times" />}
                            </span>
                        </div>}
                        <div className="dlc-dialog-header">{this.props.title}</div>
                        <div className="dlc-dialog-body" style={{ overscrollBehaviorX: 'auto' }}>
                            {this.showSubDialog()}
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </CSSTransition>
        );
    }
}

const mapStateToProps = (state: IRootState, ownProps: IDialogOwnProps) => ({
    isOpen: selectors.layout.isDialogShowing(state, ownProps.dialogName),
});

const mapDispatchToProps: IDialogDispatchProps = {
    hideDialog: () => actions.layout.hideDialog(),
};

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);

interface IDialogCloseButtonOwnProps {
    text: string;
}

type IDialogCloseButtonProps = IDialogCloseButtonOwnProps & IDialogDispatchProps;

class DialogCloseButtonComp extends React.Component<IDialogCloseButtonProps> {
    public render() {
        return <Button text={this.props.text} type="button" onClick={this.props.hideDialog} />;
    }
}

const DialogCloseButton = connect(undefined, mapDispatchToProps)(DialogCloseButtonComp);
export { DialogCloseButton };



// WEBPACK FOOTER //
// ./src/components/common/Dialog.tsx